import { render, staticRenderFns } from "./RsaPianificazioneEditGiorniAlternati.vue?vue&type=template&id=7b6c1f06"
import script from "./RsaPianificazioneEditGiorniAlternati.vue?vue&type=script&lang=js"
export * from "./RsaPianificazioneEditGiorniAlternati.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports